import { Divider, Radio,  Tag,  Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import PriceFormatter from "apps/Common/PriceFormatter";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "store/Reducers";

const { Text } = Typography;

const PackageItem = ({ item }: { item: any }) => {
  const { selectedPackages } = useSelector((state: RootState) => state.ad);
  const navigate = useNavigate()
  return (
    <div
      className={`!w-full h-[600px]  text-center rounded-3xl shadow-xl !flex !flex-col gap-4 !p-2 !items-center   md:!p-6    ${
        item.inUser
          ? "bg-gray-900 text-white border-4 border-white transform "
          : "bg-white text-black "
      }`}
    >
      {item?.inUser ? (
        <>
        <div className="">
          <Tag color="#ffc600 " className="font-semibold !p-2  rounded-full uppercase text-xs !text-black">
            Şuan Aktif
          </Tag>
        </div>

        </>
      ):
      <>
          <div className="!flex justify-center">
            <Radio value={item.id}></Radio>
          </div>
        
      </>
    
    }
      <h1
        className={`font-semibold !text-lg md:!text-2xl  ${
          item.inUser ? "text-white" : "text-black"
        }`}
      >
        {item.name}
      </h1>
      <p className=" tracking-wide ">
        <span className=" !text-lg md:!text-3xl font-semibold !flex gap-2 justify-center">
          <div>
            {item?.priceWithDiscount > 0 &&
            item?.priceWithDiscount !== item?.price ? (
              <>
                <div className="!flex justify-center">
                  <Text
                    className={` !text-red-500  !line-through !font-normal `}
                  >
                    <PriceFormatter classNames={`!font-normal `} inputPrice={item?.price} />
                     
                  </Text>
                </div>
                <div>
                {item?.priceWithDiscount === 0 ? (
                      <Text className="!text-xl !text-green-500">Ücretsiz</Text>
                    ) : (
                
                      <PriceFormatter  classNames={`!text-[20px] ${
                        item.inUser ? "!text-white" : "!text-black"
                      }`} inputPrice={item?.priceWithDiscount} />
                 
                       
                    )}
                  
                </div>
              </>
            ) : (
              <span className="!p-2 !rounded-md !bg-[#ffc600]  ">
               
                  {item?.price === 0 ? (
                    <Text className="!text-lg !font-normal !text-black !mt-2">Ücretsiz</Text>
                  ) : (
                    <>
                    <PriceFormatter inputPrice={item?.price} />
                    </>
                  )}
            
              </span>
            )}
          </div>
        </span>
      </p>
     <Divider className=" !m-0"/>
      <div className="  ">
        <p
          className={`!flex justify-center${
            item.inUser ? "text-white" : "text-black !max-h-[183px] !overflow-auto"
          } text-left !pl-1 md:!pl-4`}
        >
          <span className="material-icons align-middle !text-cente !text-xs md:!text-sm">
            {item.description}
          </span>
        </p>
      </div>
      {item.inUser ? (
        <></>
      ) : (
        <MazakaButton 
        onClick={()=>{
          if(selectedPackages?.package)
          {
            navigate("/payment?redirectUrl=/admin/panel?activePanelMenu=profile")
          }
          else{
            openNotificationWithIcon("default","Lütfen bir paket seçiniz")
          }

        }}
        className="w-full !py-4 !bg-[#FFC502] mt-8 rounded-xl !text-black">
          Paketi Satın Al
        </MazakaButton>
      )}
    </div>
  );
};

export default PackageItem;
